import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="relative w-full h-[360px] md:h-[400px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20editorial%20abstract%20background%20with%20deep%20coral%20red%20amber%20gold%20gradient%20and%20soft%20paper%20grain%20texture%2C%20subtle%20geometric%20shapes%2C%20cinematic%20wide%20composition&width=1600&height=700&seq=kanliao-cta-01&orientation=landscape"
        alt="5看料网 - 开始收藏你的第一条话题"
        title="5看料网 - 收藏、书签、标记与关注"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-foreground-950/60"></div>

      <div className="relative z-10 w-full h-full px-4 md:px-8 flex flex-col items-center justify-center text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight max-w-3xl">
          开始收藏你的第一条话题
        </h2>
        <p className="mt-4 max-w-xl text-sm md:text-base leading-7 text-background-100/90">
          收藏、保存、书签、记录、标记、关注，一次到位。把感兴趣的热点留在自己身边，随时回看。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/topics"
            className="px-7 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            浏览话题库
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 rounded-md border border-background-50/50 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-50/15 transition-colors cursor-pointer"
          >
            了解 5看料网
          </Link>
        </div>
      </div>
    </section>
  );
}